var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptIconsYahoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#34DAE2;}\n\t.st2{fill:#252A41;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st4{fill:#E3E3E3;}\n\t.st5{opacity:0.1;fill:#231F20;enable-background:new    ;}\n\t.st6{fill:#D54B3D;}\n\t.st7{fill:#D72B27;}\n\t.st8{fill:url(#Path_677_1_);}\n\t.st9{fill:#005FAC;}\n\t.st10{fill:#5F01D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(1412.873 765.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    className: "st10",
    d: "M-1412.87-758h5.57l3.24,8.29l3.28-8.29h5.42l-8.16,19.62h-5.45l2.23-5.2L-1412.87-758z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    className: "st10",
    d: "M-1394.71-750.14c1.86,0,3.37,1.51,3.37,3.37c0,1.86-1.51,3.37-3.37,3.37s-3.37-1.51-3.37-3.37 c0,0,0,0,0,0C-1398.09-748.63-1396.58-750.14-1394.71-750.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    className: "st10",
    d: "M-1390.24-751.38h-6.07l5.39-12.94h6.05L-1390.24-751.38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptIconsYahoo);
export default __webpack_public_path__ + "static/media/recrypt_icons_yahoo.07d6be05.svg";
export { ForwardRef as ReactComponent };